import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { Auth, Hub } from 'aws-amplify';
import { Router } from '@angular/router';
import { CacheService } from "../services/cache.service";
import { ConstantsService } from "../services/constants.service";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { SpinnerService } from '../services/spinner.service';
import { environment } from 'src/environments/environment';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
// import { HelperService } from '../services/helper.service';
import { interval} from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  public signupForm: UntypedFormGroup;
  public from;
  public isProcessing = false;
  public registerSuccess = false;
  public fromPricing = false
  fromsubscription: any;
  isDisabled = true;
  progress = 0;
  remainingTime = 30;
  constructor(
    private router: Router,
    private zone: NgZone,
    public constants: ConstantsService,
    private spinner: SpinnerService,
    private cache: CacheService,
    private fb: UntypedFormBuilder,
    private location: Location,
    private mixpanel: SharedMixpanelService,
    // private helperService:HelperService
  ) {
    // Used for listening to login events
    Hub.listen("auth", ({ payload: { event, data } }) => {
      if (event === "cognitoHostedUI" || event === "signedIn") {
        this.zone.run(() => this.router.navigate(['/']));
      } else {
      }
    });
  }


  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authcall()
    this.fromPricing = this.cache.fromPricingPage
    let currentUrl = document.URL.split("/")
    this.from = currentUrl.slice(3).toLocaleString().toLowerCase()
    this.cache.animateUI("easein");
    this.initialiseForm();
    this.fromsubscription = this.cache.fromPricingPage;
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  public async authcall() {
    this.cache.getAuthUser()
      .then(data => {
        let { login } = data
        if (login) {
          this.router.navigate(['/'], { replaceUrl: true });
        }
        this.spinner.hide()
      })
      .catch(error => {
        this.spinner.hide()
      })
  }
  onLoginClick(provider) {
    Auth.federatedSignIn({
      provider: provider
    });
    this.mixpanel.actions.track("signup with " + provider, {
      "Signup with": provider
    })
  }
  initialiseForm() {
    this.signupForm = this.fb.group({
      email: new UntypedFormControl('', [Validators.email, Validators.required]),
      firstName: new UntypedFormControl('', Validators.required),
      lastName: new UntypedFormControl(''),
      password: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=.*[$@#!%*?&])(?=[^A-Z]*[A-Z]).{8,}$/)
      ])
    })
  }
  async onClickSignup() {
    this.isProcessing = true;
    let username = this.signupForm.value.email.toLowerCase();;
    let password = this.signupForm.value.password;
    let email = this.signupForm.value.email.toLowerCase();
    let given_name = this.signupForm.value.firstName;
    let family_name = this.signupForm.value.lastName;
    try {
      const { user } = await Auth.signUp({
        username,
        password,
        attributes: {
          email,
          given_name,
          family_name
        }
      });
      this.mixpanel.actions.identify(email);
      this.mixpanel.actions.people.set({
        "$name": given_name,
        "$email": email,
      });
      this.mixpanel.actions.track("Signup", {
        "Name": given_name,
        "email": email,
      });
      this.registerSuccess = true;
      this.startTimer();
      this.isProcessing = false;
    } catch (error) {
      if (error.code === "UsernameExistsException") {
        document.getElementById("alert-email").style.display = "block"
      }
      this.isProcessing = false;
    }

  }
  onClickFormArea() {
    document.getElementById("alert-email").style.display = "none"
  }
  async onClickResend() {
    let username = this.signupForm.value.email.toLowerCase();
    try {
      await Auth.resendSignUp(username);
      document.getElementById("resend-alert").innerHTML = "code resent successfully"
      document.getElementById("resend").style.display = "none"
    } catch (err) {
      document.getElementById("resend-alert").innerHTML = err.message
      document.getElementById("resend").style.display = "none"
    }
  }
  onClickSowPassowrd() {
    let inputFiled = (<HTMLInputElement>document.getElementById('input-password'))
    if (inputFiled.type === 'password') {
      inputFiled.type = 'text'
    }
    else {
      inputFiled.type = 'password'
    }
  }
  gotoPrevious() {
    this.location.back();
  }

  startTimer() {
    const timer$ = interval(100).pipe(take(300)); // Emits every 100ms, for 300 times (30 seconds total)

    timer$.subscribe((val) => {
      this.remainingTime = 30 - Math.floor((val + 1) / 10); // Update every 1 second (100ms x 10)
      this.progress = ((val + 1) / 300) * 100; // Update progress smoothly every 100ms

      // After 30 seconds (300 * 100ms), enable the button
      if (val === 299) {
        this.isDisabled = false;
      }
    });
  }
}
